import { render, staticRenderFns } from "./TermsElement.vue?vue&type=template&id=46a22ccd&"
import script from "./TermsElement.vue?vue&type=script&lang=js&"
export * from "./TermsElement.vue?vue&type=script&lang=js&"
import style0 from "./TermsElement.vue?vue&type=style&index=0&id=46a22ccd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports